<div class="wc" *ngIf="gridMode">

    <!-- Leque de ações flutuante -->
    <nz-float-button-group class="wc__fab" [nzIcon]="fabMenuIcon" nzTrigger="click" nzType="primary">
        <nz-float-button *ngIf="canInsert" [nzIcon]="fabAddIcon"
            nz-tooltip [nzTooltipTitle]="'workflow.insert.new'|translateTA" nzTooltipPlacement="left"
            (nzOnClick)="addNewItem()"></nz-float-button>
        <nz-float-button *ngIf="canView" [nzIcon]="fabRefreshIcon"
            nz-tooltip [nzTooltipTitle]="'refresh'|translateTA" nzTooltipPlacement="left"
            (nzOnClick)="loadData(null)"></nz-float-button>
    </nz-float-button-group>
    <ng-template #fabMenuIcon><span nz-icon nzType="menu"></span></ng-template>
    <ng-template #fabAddIcon><span nz-icon nzType="plus"></span></ng-template>
    <ng-template #fabRefreshIcon><span nz-icon nzType="reload"></span></ng-template>

    <!-- Filtros -->
    <div class="wc-filter">
        <nz-collapse>
            <nz-collapse-panel [nzHeader]="filterHeader" [nzExtra]="filterExtra">
                <ng-template #filterHeader>{{ 'filter'|translateTA }}</ng-template>
                <ng-template #filterExtra>
                    <span class="wc-filter__desc">{{ 'workflow.filter.desc'|translateTA }}</span>
                    <span nz-icon nzType="filter" class="wc-filter__icon"
                        [class.wc-filter__icon--active]="filterActiveState"></span>
                </ng-template>

                <div class="wc-filter__grid">
                    <div class="wc-filter__line">
                        <nz-input-group [nzPrefix]="searchIcon" class="wc-filter__search">
                            <input nz-input [formControl]="inputFilter" (keyup)="updateFilter($event)"
                                placeholder="Ex: Integração de Pedidos">
                        </nz-input-group>
                        <ng-template #searchIcon><span nz-icon nzType="search"></span></ng-template>
                    </div>
                    <div class="wc-filter__line">
                        <nz-badge [nzCount]="getBadge(filterActive)" class="wc-filter__field">
                            <nz-select [formControl]="filterActive" nzMode="multiple" nzAllowClear
                                [nzPlaceHolder]="'active'|translateTA" class="wc-filter__select">
                                <nz-option *ngFor="let item of activeList" [nzValue]="item.key"
                                    [nzLabel]="item.name"></nz-option>
                            </nz-select>
                        </nz-badge>
                        <nz-badge [nzCount]="getBadge(filterCompany)" class="wc-filter__field">
                            <nz-select [formControl]="filterCompany" nzMode="multiple" nzAllowClear nzShowSearch
                                [nzPlaceHolder]="'context'|translateTA" class="wc-filter__select">
                                <nz-option *ngFor="let item of companyList" [nzValue]="item.key"
                                    [nzLabel]="item.key + ' - ' + item.name"></nz-option>
                            </nz-select>
                        </nz-badge>
                        <nz-badge [nzCount]="getBadge(filterContract)" class="wc-filter__field">
                            <nz-select [formControl]="filterContract" nzMode="multiple" nzAllowClear nzShowSearch
                                nzPlaceHolder="Contrato" class="wc-filter__select">
                                <nz-option *ngFor="let item of contractList" [nzValue]="item.key"
                                    [nzLabel]="item.key + ' - ' + item.name"></nz-option>
                            </nz-select>
                        </nz-badge>
                        <nz-badge [nzCount]="getBadge(filterMarketplace)" class="wc-filter__field">
                            <nz-select [formControl]="filterMarketplace" nzMode="multiple" nzAllowClear nzShowSearch
                                nzPlaceHolder="Canal" class="wc-filter__select">
                                <nz-option *ngFor="let item of marketPlaceList" [nzValue]="item.key"
                                    [nzLabel]="item.key + ' - ' + item.name"></nz-option>
                            </nz-select>
                        </nz-badge>
                        <nz-badge [nzCount]="getBadge(filterEnvironment)" class="wc-filter__field">
                            <nz-select [formControl]="filterEnvironment" nzMode="multiple" nzAllowClear
                                nzPlaceHolder="Ambiente" class="wc-filter__select">
                                <nz-option *ngFor="let item of enviromentList" [nzValue]="item.key"
                                    [nzLabel]="item.key + ' - ' + item.name"></nz-option>
                            </nz-select>
                        </nz-badge>
                    </div>
                </div>
            </nz-collapse-panel>
        </nz-collapse>
    </div>

    <nz-divider class="wc__divider"></nz-divider>

    <!-- Grade de integrações -->
    <nz-spin class="wc__spin" [nzSpinning]="loadingData" nzSize="large">
        <div class="wc-scroll" #scrollcontainer>
            <div nz-row class="wc-grid" [nzGutter]="[8, 8]">
                <div nz-col *ngFor="let item of mktpworkflow" [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="6">
                    <div class="wc-card">
                        <div class="wc-card__header">
                            <span class="wc-card__title" nz-tooltip [nzTooltipTitle]="item['NAME']">
                                {{ item['IDCONF'] }} - {{ item['NAME'] }}
                            </span>
                            <span nz-icon nzType="global" class="wc-card__public"
                                nz-tooltip [nzTooltipTitle]="'workflow.multiple.context'|translateTA"
                                *ngIf="item['PUBLISHED'] == 'S'"></span>
                        </div>
                        <div class="wc-card__body">
                            <p>{{ item['CODECOMPANY'] }} - {{ item['CODECOMPANY_NAME'] }}</p>
                            <p>{{ item['CODEMKTP'] }} - {{ item['CODEMKTP_NAME'] }}</p>
                            <nz-icon class="wc-card__icon" *ngIf="item['SVGICON'] != null"
                                [nzType]="'custom:' + item['SVGICON']" />
                        </div>
                        <div class="wc-card__actions">
                            <button nz-button nzType="link" (click)="editarDados(item)" *ngIf="canEdit">
                                {{ 'edit'|translateTA }}
                            </button>
                            <div class="wc-card__spacer"></div>
                            <nz-switch nzSize="small" [(ngModel)]="item['activeBOO']"
                                (ngModelChange)="itemChange(item)"></nz-switch>
                            <nz-divider nzType="vertical"></nz-divider>
                            <button nz-button nzType="text" nzShape="circle"
                                nz-dropdown [nzDropdownMenu]="cardMenu" nzTrigger="click">
                                <span nz-icon nzType="more"></span>
                            </button>
                            <nz-dropdown-menu #cardMenu="nzDropdownMenu">
                                <ul nz-menu>
                                    <li nz-menu-item (click)="editProperties(item)">
                                        <span nz-icon nzType="edit" class="wc-menu__icon"></span>
                                        <span>{{ 'workflow.properties'|translateTA }}</span>
                                    </li>
                                    <li nz-menu-item (click)="openLog(item)">
                                        <span nz-icon nzType="history" class="wc-menu__icon"></span>
                                        <span>{{ 'workflow.log.execution'|translateTA }}</span>
                                    </li>
                                    <li nz-menu-item nzDanger (click)="openThread(item)">
                                        <span nz-icon nzType="stop" class="wc-menu__icon"></span>
                                        <span>{{ 'workflow.stop.execution'|translateTA }}</span>
                                    </li>
                                </ul>
                            </nz-dropdown-menu>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </nz-spin>

    <div class="wc-summary">
        <div class="wc-summary__total">{{ 'total.lines'|translateTA }}: {{ mktpworkflow_temp.length }}</div>
        <span class="wc-summary__spacer"></span>
        <div class="wc-summary__lines">{{ 'lines'|translateTA }}: {{ mktpworkflow.length }}</div>
    </div>
</div>

<!-- Modo edição do fluxo -->
<div class="wc-edit" *ngIf="!gridMode">
    <div class="wc-edit__toolbar">
        <button nz-button nzShape="circle" nz-tooltip [nzTooltipTitle]="'back'|translateTA"
            (click)="gridMode = true">
            <span nz-icon nzType="rollback"></span>
        </button>
        <span class="wc-edit__title">{{ selectedItem['IDCONF'] }} - {{ selectedItem['NAME'] }}</span>
    </div>
    <webhook-edit [selectedItem]="selectedItem"></webhook-edit>
</div>
